// extracted by mini-css-extract-plugin
export default {"root":"textInput_root__2+bBY","wrap_root":"textInput_wrap_root__WYlf8"};